import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import {useState} from 'react';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {loginOperator} from '../utils/LoginApi';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';

export default function OperatorLogin({onLoginAttempt}) {
  const {t} = useTranslation();

  const [submitting, setSubmitting] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    const loginPromise = loginOperator(username, password);
    try {
      const response = await loginPromise;
      if (response.status === 200) {
        toast.success('Login Successful');
      } else {
        toast.error('Login Failed');
      }

      onLoginAttempt();
    } finally {
      setSubmitting(false);
    }
  };

  const onPasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const onEmailChange = (event) => {
    setUsername(event.target.value);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box sx={{display: 'flex'}}>
      <Container maxWidth="sm">
        <Box sx={{mt: 7, mb: 12}}>
          <Paper sx={{py: {xs: 4, md: 8}, px: {xs: 3, md: 6}}}>
            <Typography variant="h2" gutterBottom marked="center" align="center">
              {t('sign-in')}
            </Typography>

            <Box component="form" onSubmit={onSubmit} sx={{mt: 6}}>
              <TextField
                id="username"
                required
                name="username"
                label={t('username')}
                autoComplete="username"
                autoFocus
                fullWidth
                margin="normal"
                size="large"
                value={username}
                onChange={onEmailChange}
              />
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="password"> {t('password')}</InputLabel>
                <OutlinedInput
                  id="password"
                  required
                  name="password"
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={onPasswordChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
              <Button
                type={'submit'}
                disabled={submitting}
                fullWidth
              >
                {submitting ? <CircularProgress color="primary"/> : t('sign-in-button')}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

OperatorLogin.propTypes = {
  onLoginAttempt: PropTypes.func.isRequired,
};
